import { z } from 'zod'

export const ActivateUserSchema = z.object({
  acceptTerms: z.boolean(),
})

export type ActivateUserForm = z.infer<typeof ActivateUserSchema>
